class watch {
  constructor(
    relojId,
    rcpComId,
    cRCPId,
    nombre,
    descripcion,
    habilitado,
    reintentos
  ) {
    this.relojId = relojId;
    this.rcpComId = rcpComId;
    this.cRCPId = cRCPId;
    this.nombre = nombre;
    this.descripcion = descripcion;
    this.habilitado = habilitado;
    this.reintentos = reintentos;
  }
  static fromJson({
    relojId,
    rcpComId,
    cRCPId,
    nombre,
    descripcion,
    habilitado,
    reintentos,
  }) {
    return new watch(
      relojId,
      rcpComId,
      cRCPId,
      nombre,
      descripcion,
      habilitado,
      reintentos
    );
  }
}

export default watch;
